export { fontSizes } from '../../dls';
